import { getProvider } from '../../../apollo'
import gql from 'graphql-tag'
import { splitError } from '../../../helper/splitError'

const CreditCardModule = {
  namespaced: true,
  state: {
    token: null,
    completed: false,
    creditCardInformation: null
  },
  actions: {
    async initCreditCardPayment ({ commit, state, rootGetters }, { personalData, processName }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation ${processName} ($request: CreditCardTokenRequestInput!) {
          initializeCreditCardPayment (request: $request) {
            token
          }
        }`,
        variables: {
          request: {
            ...personalData,
            brand: rootGetters.brand
          }
        }
      }).then((response) => {
        if (response.data.initializeCreditCardPayment) {
          commit('storeCcToken', response.data.initializeCreditCardPayment)
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async postProcessCreditCard ({ commit, state, rootGetters }, { token, processName }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query ${processName} ($brand: String!, $token: String!) {
          creditCardInformation(ccInformationRequest: {
            brand: $brand
            token: $token
          }) {
            registrationId
            bin
            company
            lastDigits
            holder
            expiryMonth
            expiryYear
          }
        }`,
        variables: {
          brand: rootGetters.brand,
          token: token
        }
      }).then((response) => {
        if (response.data.creditCardInformation) {
          commit('storeCreditCard', response.data.creditCardInformation)
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    storeCcToken: (state, { token }) => {
      state.token = token
    },
    markCreditCardCompleted: (state) => {
      state.completed = true
    },
    restartProcess: (state) => {
      state.token = null
      state.completed = false
    },
    storeCreditCard (state, creditCardInformation) {
      state.creditCardInformation = creditCardInformation
    },
    clearCreditCard (state) {
      state.creditCardInformation = null
    }
  },
  getters: {
    token: state => {
      return state.token
    },
    step: state => {
      if (state.token === null) {
        return 'before'
      }
      if (state.completed) {
        return 'completed'
      }
      return 'pending'
    },
    creditCard: state => state.creditCardInformation
  }
}

export {
  CreditCardModule
}
